import script from "./PurchaseView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseView.vue?vue&type=script&setup=true&lang=ts"

import "./PurchaseView.vue?vue&type=style&index=0&id=a074451e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a074451e"]])

export default __exports__